import { observer } from 'mobx-react-lite';

import type AssetImportService from '@backgroundTasks/services/AssetsImportService/AssetsImportService';

import useToggle from 'src/hooks/useToggle';
import BackgroundTasksBoxFooter from './BackgroundTasksBoxFooter/BackgroundTasksBoxFooter';
import BackgroundTasksBoxHeader from './BackgroundTasksBoxHeader/BackgroundTasksBoxHeader';
import BackgroundTaskProgress from './BackgroundTaskProgress/BackgroundTaskProgress';

import type AssetDownloadService from '../../services/AssetDownloadService/AssetDownloadService';

import './BackgroundTasksBox.scss';

type BackgroundTasksBoxProps = {
	assetDownloadService: AssetDownloadService,
	assetImportService: AssetImportService,
	onBoxClosed?: () => void
};

const BackgroundTasksBox = ( {
	assetDownloadService, assetImportService, onBoxClosed = () => {}
}: BackgroundTasksBoxProps ) => {
	const [ isMinimized, minimize ] = useToggle();

	const { downloads, unfinishedDownloadsCount } = assetDownloadService;
	const { imports, unfinishedImportsCount } = assetImportService;
	const sortedTasks = (
		[ ...downloads, ...imports ].sort( ( a, b ) => b.createdAt.getTime() - a.createdAt.getTime() )
	);
	const hasFinished = unfinishedDownloadsCount === 0 && unfinishedImportsCount === 0;

	return (
		<div className="BackgroundTasksBox">
			<BackgroundTasksBoxHeader
				hasFinished={hasFinished}
				isMinimized={isMinimized}
				onMinimize={minimize}
				onClose={onBoxClosed}
			/>
			{!isMinimized && (
				<div className="download-list">
					{sortedTasks.map( task => (
						<BackgroundTaskProgress
							key={task.id}
							backgroundTask={task}
							testID={`background-task-${task.id}`}
						/>
					) )}
				</div>
			)}
			{!isMinimized && unfinishedDownloadsCount > 1 && (
				<BackgroundTasksBoxFooter
					onCancelAllClicked={() => assetDownloadService.cancelAllDownloads()}
				/>
			)}
		</div>
	);
};

export default observer( BackgroundTasksBox );
